module.exports = __webpack_public_path__ + "img/h5Pay.bd130783.png";